<template>
  <div>
    <NewsPage v-if="type === 'news' || type === 'api' || type === 'document'" />
    <WeMedia
      v-if="
        type === 'twitter' ||
        type === 'weibo' ||
        type === 'facebook' ||
        type === 'vk' ||
        type === 'tg' ||
        type === 'ins'
      "
    />
    <Toutiao v-if="type === 'toutiao'" />
    <Wechat v-if="type === 'wechat'" />
  </div>
</template>

<script>
import NewsPage from './News/index'
import WeMedia from './WeMedia/index'
import Toutiao from './Toutiao/index'
import Wechat from './Wechat/index'

export default {
  components: {
    NewsPage,
    WeMedia,
    Toutiao,
    Wechat
  },
  data() {
    return {
      type: ''
    }
  },
  mounted() {
    const { type } = this.$route.query
    if (type) {
      this.type = type
    }
  }
}
</script>
